import React from 'react';
import { Link } from 'react-router-dom';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const Intro = () => (
	<section id="intro">
		<Link to="/" className="logo">
			<img src={`${PUBLIC_URL}/images/me.jpg`} alt="" />
		</Link>
		<header>
			<h2>Vadim Isakov</h2>
			<p><a href="mailto:dev@iaotle.dev">dev@iaotle.dev</a></p>
		</header>
	</section>
);

export default Intro;
